import React from 'react';

interface LoaderProps {
  small?: boolean;
  xsmall?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ small, xsmall }) => {
  return (
    <div className={`flex justify-center items-center h-full`}>
      <div className={`${small ? 'w-8 h-8' : xsmall ? 'w-4 h-4 border-2' : 'w-16 h-16'} border-4 border-gray-200 border-t-orange-500 rounded-full animate-spin`}></div>
    </div>
  );
};

export default Loader;